const {
  REACT_APP_API_KEY_NAME,
  REACT_APP_API_KEY_VALUE,
  REACT_APP_SEARCH_URL_PUBLISH,
  REACT_APP_SEARCH_URL_AUTHOR,
  REACT_APP_NO_DATA_IMAGE_URL,
  REACT_APP_PAGE_NOT_FOUND_URL,
  REACT_APP_EXCLUDED_UNIT_MEASURES_FOR_MAP,
  REACT_APP_DATA_APPS_FILES_DOMAIN,
  REACT_APP_DATA360_API_DOMAIN,
  REACT_APP_EXT_DATA_PORTAL_DOMAIN,
  REACT_APP_DATA360_DOMAIN,
} = process.env

const buildEndpointList = () => {
  const data360APIDomain = REACT_APP_DATA360_API_DOMAIN
  const extDataPortalDomain = REACT_APP_EXT_DATA_PORTAL_DOMAIN
  const data360Domain = REACT_APP_DATA360_DOMAIN
  const dataAppsFilesDomain = REACT_APP_DATA_APPS_FILES_DOMAIN

  return [
    {
      apiEndpoint: `${data360APIDomain}/data360/portal/v1/metadata`,
      endpointLabel: "portalMetadata",
    },
    {
      apiEndpoint: `${data360APIDomain}/data360/portal/v1/get_entities_by_id`,
      endpointLabel: "getEntitiesById",
    },
    {
      apiEndpoint: `${data360APIDomain}/data360/portal/v1/you_might_also_like`,
      endpointLabel: "youMightAlsoLike",
    },
    {
      apiEndpoint: `${data360APIDomain}/data360/portal/v1/adminMetadata`,
      endpointLabel: "adminMetadata",
    },
    {
      apiEndpoint: `${data360APIDomain}/data360/portal/v1/hierarchy?type=country`,
      endpointLabel: "grouping",
    },
    {
      apiEndpoint: `${data360APIDomain}/data360/portal/v1/data`,
      endpointLabel: "data",
    },
    {
      apiEndpoint: `${data360APIDomain}/data360/portal/v1/hierarchy?type=site&id=HCL_TOPICS_D360`,
      endpointLabel: "hierarchy",
    },
    {
      apiEndpoint: `${data360Domain}/content/dam/sites/data/data360/api/World-including-disputed.json`,
      endpointLabel: "mapboundaries",
    },
    {
      apiEndpoint: `${data360Domain}/content/dam/sites/data/data360/api/centroids.json`,
      endpointLabel: "mapcentroids",
    },
    {
      apiEndpoint: `${data360Domain}/content/dam/sites/data/data360/api/wb-regions.geojson`,
      endpointLabel: "regionboundaries",
    },
    {
      apiEndpoint: `${data360Domain}/content/dam/sites/data/data360/api/wb-continent.geosjon`,
      endpointLabel: "continentboundaries",
    },
    {
      apiEndpoint: `${extDataPortalDomain}/data360/metadata/countryHierarchy`,
      endpointLabel: "countryHierarchy",
    },
    {
      apiEndpoint: `${data360APIDomain}/data360/portal/v1/dimensions`,
      endpointLabel: "dimensions",
    },
    {
      apiEndpoint: `${dataAppsFilesDomain}/codelist/WB/CL_REF_GROUPINGS.json`,
      endpointLabel: 'codelistRefGroupings',
    },
  ]
}

const appConfig = {
  mode: "publish",
  name: "indicatorProfile",
  site: "data360",
  headerTitle: "Indicator",
  brandSlug: "World Bank Data360",
  apiKeyName: REACT_APP_API_KEY_NAME || "",
  apiKeyValue: REACT_APP_API_KEY_VALUE || "",
  secondIndicator: "WB_WDI_NY_GDP_MKTP_KD_ZG",
  searchURLPublish: REACT_APP_SEARCH_URL_PUBLISH || "/en/data360/search",
  searchURLAuthor:
    REACT_APP_SEARCH_URL_AUTHOR || "/content/data/sites/data360/en/search",
  noDataImageURL:
    REACT_APP_NO_DATA_IMAGE_URL ||
    "https://www.worldbank.org/content/dam/sites/data/data360/img/Search-icon-for-nodata.svg",
  pageNotFoundURL:
    REACT_APP_PAGE_NOT_FOUND_URL ||
    "https://www.worldbank.org/404_response.html",
  excludedUnitMeasuresForMap:
    REACT_APP_EXCLUDED_UNIT_MEASURES_FOR_MAP || "XDC,XDC_CUR",
  endpointList: buildEndpointList(),
}

export default appConfig
